import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Store } from '@ngrx/store';
import { UserState } from '../store/User/UserReducer';
import { InitUser } from '../store/User/UserActions';

@Injectable({
  providedIn: 'root',
})
export class ClearingWebInitService {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly userStore: Store<UserState>,
  ) {}

  async initApp() {
    try {
      console.log('Initializing app - fetching CSRF token...');
      const csrfResult = await this.authenticationService.fetchCsrfToken();

      if (!csrfResult) {
        console.log('No CSRF token available - user needs to login');
        return;
      }

      console.log(
        'CSRF token obtained, checking user authentication status...',
      );

      try {
        const userInfoResponse = await new Promise<any>((resolve, reject) => {
          this.authenticationService.userInfo().subscribe({
            next: (response) => resolve(response),
            error: (error) => reject(error),
          });
        });

        if (userInfoResponse && userInfoResponse.userinfo) {
          console.log('User is authenticated, initializing user state...');
          this.userStore.dispatch(
            new InitUser(userInfoResponse.userinfo, null),
          );
        } else {
          console.log('No user info available - user needs to login');
        }
      } catch (error) {
        if (error.status === 401 || error.status === 403) {
          console.log('User not authenticated - will redirect to login');
        } else {
          console.error('Error fetching user info:', error);
        }
      }
    } catch (error) {
      console.error('Error during app initialization:', error);
    }
  }
}
